module.exports = __webpack_public_path__ + "favicon/android-chrome-512x512.png";